<div class="carregando">
    <img class="loading" src="../../../../assets/icons/icon-only.png">
<!--    <ion-spinner name="bubbles" color="primary"></ion-spinner>-->
    <p>Carregando...</p>
</div>
